import AddPersonalInformation from './AddPersonalInformation.gql';

export default AddPersonalInformation;
